import { SiteManager } from "@kosmod/graphics-2d"
import { ModalManager } from "@kosmod/kit"
import { kosmodSite } from "../pages"
import { createContext, useContext } from "@lukekaalim/act";

/**
 * Interfaces available to the frontend as
 * provided by the top level component.
 */
export type FrontendServices = {
  modal: ModalManager,
  site: SiteManager<typeof kosmodSite>
};

export const FrontendServicesContext = createContext<FrontendServices | null>(null);

export const useFrontendServices = () => {
  const services = useContext(FrontendServicesContext)
  if (!services)
    throw new Error(`No frontend services provided`);
  return services;
}